$(function() {
  $('.soumission-btn').on('click', function() {
    var that = $(this),
    fetchUrl = that.data('fetch');

    if ($('#soumission-container #soumission-form').length > 0) {
      $('#soumission-container .soumission #soumission-form .alerts').find('.alert').remove();
      $('#soumission-container .soumission #soumission-form').find('input,textarea').removeClass('parsley-error');
      $('#soumission-container .soumission #soumission-form').find('input,textarea').val('');
      $('#soumission-container .soumission #soumission-form .inside-form').show();
      $('#soumission-container .soumission').fadeIn("slow");

      return;
    }

    $.get(fetchUrl, function(response) {
      $('#soumission-container').append(response);
      $('#soumission-container .soumission').fadeIn("slow");
    });
  });

  $(document).on('click', '#soumission-container .soumission .close', function() {
    $('#soumission-container .soumission').fadeOut("slow");
  });

  $(document).on('click', '#soumission-container .soumission #soumission-submit', function() {
    var that = $(this),
    form = $('#soumission-container .soumission #soumission-form'),
    formParsley = form.parsley();

    formParsley.validate();

    if (formParsley.isValid()) {
      that.attr('disabled', 'disabled').css('opacity', '0.6');

      grecaptcha.execute($('#recaptchaScript').data('sitekey'), {action: 'soumission'}).then(function(token) {
        form.find('[name="g-recaptcha-response"]').val(token);

        $.ajax({
          url: form.attr('action'),
          type: form.attr('method'),
          dataType: 'JSON',
          data: form.serializeArray()
        })
        .done(function(response) {
          $('#soumission-container .soumission #soumission-form .alerts').find('.alert').remove();

          if (response.success) {
            $('#soumission-container .soumission #soumission-form .alerts').append('<p class="alert alert-success">' + response.message + '</p>')
            $('#soumission-container .soumission #soumission-form').find('input,textarea').val('');
            $('#soumission-container .soumission #soumission-form .inside-form').hide();

            var cookieAccepted = readCookie("cookieAccepted");
            if (!cookieAccepted){
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
              'event': 'popinSubmit'
              });
            }
          }
          else {
            $('#soumission-container .soumission #soumission-form .alerts').append('<p class="alert alert-error">' + response.message + '</p>')
          }
        })
        .fail(function() {
          $('#soumission-container .soumission #soumission-form .alerts').find('.alert').remove();
          $('#soumission-container .soumission #soumission-form .alerts').append('<p class="alert alert-error">Il est impossible d\'envoyer votre demande de soumission. Veuillez réessayer ou nous contacter si l\'erreur persiste.</p>')
        })
        .always(function() {
          that.removeAttr('disabled').css('opacity', '1');
        });
      });
    }
  });

  $(document).on('submit', '#soumission-container .soumission #soumission-form', function(e) {
    e.preventDefault();

    $('#soumission-container .soumission #soumission-submit').trigger('click');
  });

  $(document).on('keyup', function(e) {
    if ($('#soumission-container .soumission').is(':visible') && e.which == 27) {
      $('#soumission-container .soumission .close').trigger('click');
    }
  });
});